"use client";
import { useEffect, useRef, useState } from "react";
import { submitBugReport } from "./submitBugReport.js";
import { createElementCapture, withElementCapture } from "./elementCapture.js";
import { createBippyPinEnricher } from "./pinSource.js";
import { createPinSender } from "./pinSender.js";

export function BugReportWidget(): JSX.Element {
  const note = useRef({ summary: "", did: "", expected: "", got: "" });
  const [issueUrl, setIssueUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let dispose: (() => void) | undefined;
    const capture = createElementCapture(document);
    (async () => {
      const { mountPinpoint, MemoryStore } = await import("@agent-native/pinpoint");
      const store = withElementCapture(new MemoryStore(), capture);
      const result = mountPinpoint({
        storage: store, autoSubmit: false, includeSourcePaths: true, clearOnSend: true,
        sendToAgent: createPinSender({
          store,
          enrich: createBippyPinEnricher(capture),
          submit: async (pins) => {
            try {
              const { issueUrl } = await submitBugReport({
                ...note.current, pageUrl: location.href, pins,
                diagnostics: window.__briolinDiag?.snapshot() ?? [],
              });
              setIssueUrl(issueUrl); setError(null);
            } catch (e) { setError((e as Error).message); throw e; }
          },
        }),
      });
      dispose = result.dispose;
    })();
    return () => { capture.dispose(); dispose?.(); };
  }, []);

  return (
    <div data-testid="bug-report-widget" style={{ position: "fixed", right: 16, bottom: 16, zIndex: 9999 }}>
      <details>
        <summary title="Сообщить о баге (Ctrl+Shift+.)" style={{ cursor: "pointer" }}>🐞 Баг</summary>
        <div style={{ display: "grid", gap: 4, padding: 8, background: "#fff", border: "1px solid #ccc", borderRadius: 8 }}>
          <input placeholder="Короткое описание" onChange={(e) => (note.current.summary = e.target.value)} />
          <input placeholder="Что делал" onChange={(e) => (note.current.did = e.target.value)} />
          <input placeholder="Что ожидал" onChange={(e) => (note.current.expected = e.target.value)} />
          <input placeholder="Что получил" onChange={(e) => (note.current.got = e.target.value)} />
          <small>Нажмите Ctrl/Cmd+Shift+. и ткните в элемент, затем отправьте.</small>
          {issueUrl && <a href={issueUrl} target="_blank" rel="noopener">Отправлено ✓</a>}
          {error && <span role="alert">Не отправилось: {error}. Пины сохранены, повторите.</span>}
        </div>
      </details>
    </div>
  );
}
